import { SVCheckbox } from '@/components/core';
import { FORM_FIELDS } from '@/constants/formFields';
import { Card, Typography, Grid, Stack } from '@mui/material';

export default function PermissionsSection() {
  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Permissions
      </Typography>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            Teammates
          </Typography>
          <Stack spacing={1}>
            <SVCheckbox
              name="teammateCreatePerm"
              {...FORM_FIELDS.TEAMMATE_CREATE_PERM}
            />
            <SVCheckbox
              name="teammateUpdatePerm"
              {...FORM_FIELDS.TEAMMATE_UPDATE_PERM}
            />
            <SVCheckbox
              name="teammateDeactivateReactivatePerm"
              {...FORM_FIELDS.TEAMMATE_DEACTIVATE_REACTIVATE_PERM}
            />
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
}
